import { ThemePart } from './ThemePart';
export class ThemeModule extends ThemePart {
    get $partType$() { return 'tmod'; }
}
ThemeModule.UnknownModule = class UnknownModule extends ThemeModule {
    init() { }
    ;
};
